import { defineStore } from 'pinia';
interface State {
  donationId: string;
  isEdit: boolean;
  loading: boolean;
  household: any;
  pageData: any;
  rowData: any;
}

export default defineStore('people', {
  state: (): State => ({
    donationId: '',
    isEdit: false,
    loading: false,
    household: {},
    pageData: {},
    rowData: {},
  }),

  getters: {
    people: (state: State) => state.pageData?.data || {},
  },
});
